import React from 'react';
import { TableRow } from '@mui/material';
import { ArcTableRowProps } from './types';

const ArcTableRow: React.FC<ArcTableRowProps> = (props) => {
  return <TableRow {...props} />;
};

export default ArcTableRow;